import {
    CanActivate,
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
} from "@angular/router";
import { IAuthService } from "../services/api/contracts/auth-service";
import { Inject, Injectable } from "@angular/core";
import { Location } from "@angular/common";
import { UserRoles } from '../models/enums/userRoles';

@Injectable({
    providedIn: "root",
})
export class GuestRoleGuard implements CanActivate {
    userRoles = UserRoles;

    constructor(
        private router: Router,
        private location: Location,
        @Inject("IAuthService") private authService: IAuthService
    ) { }

    async canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        let isAuthenticated = await this.authService.isAuthenticated();
        if (isAuthenticated) {
            let currentUser: any;
            try {
                currentUser = await this.authService.getCurrentProfile();
            } catch {
                await this.router.navigate(["/login"]);
                return false;
            }
            if (
                currentUser.currentRole == this.userRoles.Operador ||
                (currentUser.roles.length == 1 &&
                    currentUser.roles.includes(this.userRoles.Operador))
            ) {
                return true;
            } else {
                this.location.back();
                return false;
            }
        } else {
            await this.router.navigate(["/login"]);
        }
    }
}
